module.exports = __webpack_public_path__ + "static/enhanced-curve-1f98c53f5b85615d85e9ea9a94d56ede.svg";